'use client';
import { Tab, Tabs } from '@heroui/tabs';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import React, { useState } from 'react';
import { useIsMobile } from '@/app/hooks/use-is-mobile';

type MonthYearToggleProps = {
  setIsMonthlyRate: React.Dispatch<React.SetStateAction<boolean>>;
};
export default function MonthYearToggle({
  setIsMonthlyRate,
}: MonthYearToggleProps) {
  const [selectedTab, setSelectedTab] = useState<'year' | 'month'>('year');
  const t = useTranslations('priceComparison');
  const tabStyles = 'flex items-center gap-x-2.5 justify-center font-medium';
  const isMobile = useIsMobile();

  return (
    <div className="w-full">
      <Tabs
        fullWidth={isMobile}
        aria-label="Timeframe tabs"
        radius="full"
        size="md"
        classNames={{
          tabList:
            'bg-subtle border border-[var(--color-border-default)] rounded-[50px] min-h-[44px] p-[6px] gap-x-1',
          cursor: 'outline outline-1 outline-[var(--color-border-default)]',
          tabContent:
            'group-data-[selected=true]:text-black text-[var(--color-text-subtle)] flex-1 p-2',
        }}
        selectedKey={selectedTab}
        onSelectionChange={(key) => {
          setSelectedTab(key as 'year' | 'month');
          setIsMonthlyRate(key == 'month');
        }}
      >
        {[
          { title: t('perYear'), term: 'year' },
          { title: t('perMonth'), term: 'month' },
        ].map((tab) => (
          <Tab
            className={!isMobile ? 'w-auto' : ''}
            key={tab.term}
            title={
              <div className={tabStyles}>
                <Image
                  data-testid={`savings-${tab.term}-image`}
                  src={`/images/${selectedTab == tab.term ? 'black' : 'gray'}-calendar-${tab.term}-icon.svg`}
                  alt={`calendar ${tab.term} icon`}
                  width={15}
                  height={15}
                />
                <span
                  data-testid={`savings-${tab.term}-title`}
                  className="font-medium leading-5"
                >
                  {tab.title}
                </span>
              </div>
            }
          />
        ))}
      </Tabs>
    </div>
  );
}
